import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ContactMethods = () => {
  const contactMethods = [
    {
      id: 'email',
      icon: 'Mail',
      title: 'Email Support',
      description: 'Your primary source of contact and support',
      contact: 'support@cynizee.com',
      responseTime: 'Response within 24 hours',
      availability: 'Mon-Fri, 9:00 AM - 7:00 PM CT',
      color: 'bg-primary',
      action: () => window.location.href = 'mailto:support@cynizee.com'
    }
  ];

  return (
    <div className="space-y-8">
      {/* Primary Contact Methods */}
      <div>
        <h3 className="text-xl font-heading font-bold text-foreground mb-6">
          Get in Touch
        </h3>
        <div className="grid grid-cols-1 gap-6">
          {contactMethods?.map((method) => (
            <div
              key={method?.id}
              className="bg-card rounded-xl p-8 border border-border shadow-soft hover:shadow-elevation transition-all duration-300 hover:-translate-y-1"
            >
              <div className="flex items-start space-x-6">
                <div className={`w-16 h-16 ${method?.color} rounded-xl flex items-center justify-center flex-shrink-0`}>
                  <Icon name={method?.icon} size={32} className="text-white" />
                </div>
                <div className="flex-1 min-w-0">
                  <h4 className="text-2xl font-heading font-bold text-foreground mb-3">
                    {method?.title}
                  </h4>
                  <p className="text-lg text-text-secondary mb-6">
                    {method?.description}
                  </p>
                  <div className="space-y-3 mb-6">
                    <div className="flex items-center space-x-3">
                      <Icon name="Clock" size={18} className="text-text-secondary" />
                      <span className="text-foreground font-medium">
                        {method?.responseTime}
                      </span>
                    </div>
                    <div className="flex items-center space-x-3">
                      <Icon name="Calendar" size={18} className="text-text-secondary" />
                      <span className="text-foreground font-medium">
                        {method?.availability}
                      </span>
                    </div>
                    <div className="flex items-center space-x-3">
                      <Icon name="User" size={18} className="text-text-secondary" />
                      <span className="text-foreground font-medium">
                        One-person business with dedicated support
                      </span>
                    </div>
                  </div>
                  
                  <div className="bg-muted/30 rounded-lg p-4 mb-6">
                    <p className="text-lg font-semibold text-foreground mb-2">
                      {method?.contact}
                    </p>
                    <p className="text-sm text-text-secondary">
                      Email is our primary communication channel. We prioritize family-critical issues and respond to all inquiries within our business hours.
                    </p>
                  </div>

                  <Button
                    variant="default"
                    size="lg"
                    onClick={method?.action}
                    iconName="ExternalLink"
                    iconPosition="right"
                    iconSize={18}
                    className="w-full sm:w-auto"
                  >
                    Send Email Now
                  </Button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Business Information */}
      <div className="bg-gradient-to-r from-primary/5 to-secondary/5 rounded-xl p-6 border border-primary/10">
        <div className="flex items-start space-x-4">
          <div className="w-12 h-12 bg-primary rounded-lg flex items-center justify-center flex-shrink-0">
            <Icon name="Info" size={24} className="text-white" />
          </div>
          <div>
            <h4 className="font-heading font-semibold text-foreground mb-2">
              About Our Support
            </h4>
            <p className="text-text-secondary mb-4">
              Cynizee is a one-person business dedicated to helping families achieve organization and harmony. 
              While we may not offer 24/7 support, every inquiry receives personal attention and thoughtful responses.
            </p>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 text-sm">
              <div className="flex items-center space-x-2">
                <Icon name="Clock" size={16} className="text-success" />
                <span className="text-foreground"><strong>Business Hours:</strong> 9:00 AM - 7:00 PM CT</span>
              </div>
              <div className="flex items-center space-x-2">
                <Icon name="Calendar" size={16} className="text-success" />
                <span className="text-foreground"><strong>Days:</strong> Monday - Friday</span>
              </div>
              <div className="flex items-center space-x-2">
                <Icon name="Mail" size={16} className="text-success" />
                <span className="text-foreground"><strong>Email Only:</strong> Primary contact method</span>
              </div>
              <div className="flex items-center space-x-2">
                <Icon name="Users" size={16} className="text-success" />
                <span className="text-foreground"><strong>Family-Focused:</strong> Understanding real family needs</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Emergency Contact Info */}
      <div className="bg-warning/10 border border-warning/20 rounded-lg p-6">
        <div className="flex items-start space-x-3">
          <Icon name="AlertTriangle" size={20} className="text-warning flex-shrink-0 mt-0.5" />
          <div>
            <h4 className="font-heading font-semibold text-foreground mb-2">
              Need Immediate Help?
            </h4>
            <p className="text-sm text-text-secondary mb-3">
              For urgent technical issues affecting your family's daily routine, please mark your inquiry as "Urgent" in the contact form above. 
              We prioritize family-critical issues and respond as quickly as possible during business hours.
            </p>
            <p className="text-xs text-text-secondary">
              <strong>Business Hours:</strong> Monday-Friday, 9:00 AM - 7:00 PM Central Time
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactMethods;